<template>
  <div>
    <div
      class="modal__cape"
      @click="close"
    />

    <div class="modal__box">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: 'Modal',

  props: {
    close: {
      type: Function,
      required: true,
    },
  },

  data: () => {
    return {}
  },

  computed: {},

  mounted() {},

  methods: {},
}
</script>

<style lang='scss' scoped>
@import '../../../sass/_variables.scss';
@import '../../../sass/_mixins.scss';

.modal {
  &__cape {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(black, .5);
    z-index: 1;
  }

  &__box {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background-color: #1f1f1f;
    border-radius: 8px;
    max-width: 600px;
    padding: 30px;
    z-index: 2;
    width: 90%;

     @include bp('sm') {
      width: auto;
     }
  }
}
</style>
